import { Component, OnInit, NgZone } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';
import { SignalRService } from 'src/app/services/signalr.service';
import { IdObfuscator } from 'src/app/utils/id-obfuscator.util';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-receptions',
  templateUrl: './receptions.component.html',
  styleUrls: ['./receptions.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ReceptionsComponent implements OnInit {
 
  DocumentBodyLoading:boolean;
  loading:boolean;

  loadingDocumentInformation:boolean;
  loadingReceptionID:string;
  loadingPOMatch:boolean;
  loadingPOMatchIndex:number = 0;
  loadingPOMatchTotal:number = 0;
  AllSelected:boolean;

  Receptions:any[];
  Filter: {[k: string]: any} = {};
  Totals: {[k: string]: any} = {};

  EFacturaFilter: {[k: string]: any} = {};

  ShowDeleteSpendingQuestion:boolean;
  showFilter:boolean;
  partner:any;
  currentPartner:any;

  PaymentCategories:any[];
  BankAccounts:any[];
  PaymentTypes:any[];

  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DocumentStatuses:any[];
  Periods:any[];
  SortingOrders:any[];
  CountryFilterOptions:any[];
  TranzactionTypes:any[];
  currentPayment:{[k: string]: any} = {};

  showEditPartnerPopUp:boolean;

  ReceptionPrecision:any;

  SuggestedPayments:any[];
  ShowSuggestionPaymentsContainer:boolean;
  ShowSuggestedPaymentModifier:boolean;
  PaymentTotals:any[];
  PartnerTypes:any[];
  ReceivedStatuses:any[];

  currency:any;
  newPartnerCountry:any;
  newPartnerBank:any;
  newPartner:any;

  searchTerm:string;
  resultsLength = 0;
  pageSize = 999999;

  ShowPaymentContainer:boolean;

  Partners:any[];
  countryID:number;
  activeFilters:{[k: string]: any} = [];
  EFacturaSupplierFileRowTypes:any[];

  EFacturaSupplierFiles:{[k: string]: any} = [];

  Products:any[];
  CurrentReception: {[k: string]: any} = {};

// Set the minimum date (60 days behind) and maximum date (today)
today = moment().format('YYYY-MM-DD'); 
pastDateLimit = moment().subtract(60, 'days');

EFacturaFromDate = new FormControl(moment()); // Initialize with today's date
EFacturaToDate = new FormControl({value: this.today});    // Initialize with today's date

// For the maxDate and minDate restrictions in the template
minDate = this.pastDateLimit.toDate(); // Convert moment to Date object
maxDate = this.today;         // Convert moment to Date object

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  CollectionDate = new FormControl(moment());

  IsCollectivePayment:boolean;
  PaymentRemainingValue:any;

  showReceptionVisualizer:boolean;
  searchPartnerUpdate = new Subject<string>();

  // Intrastat Arrivals Progress
  ShowIntrastatProgress: boolean = false;
  IntrastatProgressPercent: number = 0;
  IntrastatProgressMessage: string = '';
  IntrastatDetailMessage: string = '';
  IntrastatCurrentItem: number = 0;
  IntrastatTotalItems: number = 0;
  ShowIntrastatValidation: boolean = false;
  IntrastatDeclarations: any[] = [];

  constructor(
    public parent: DashboardComponent,
    private service: SharedService,
    private cookieService: CookieService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private signalRService: SignalRService,
    private ngZone: NgZone
  ) {

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    // Debounce search.
    this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, this.countryID, true);
      });
  }

  ngOnInit(): void {
    this.showFilter = false;
    this.DocumentBodyLoading = false;
    this.InitializeFilter();
    this.InitializeEFacturaFilter();
    this.GetReceptionsMasterData();
    this.countryID = null;
    this.IsCollectivePayment = false;

    this.GetShippingMasterData();
  }

  GetReceptionsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetReceptionsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DocTypes = response["DocTypes"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.currency = this.Currencies[0];
        this.ReceptionPrecision = this.DecimalPrecisions[0];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DocumentStatuses = response["DocumentStatuses"];
        
        this.Periods = response["Periods"];
        this.Filter.Period = this.Periods[2];
        this.AddActiveFilter(this.Filter.Period.Name, 'Period');

        this.SortingOrders = response["SortingOrders"];
        this.CountryFilterOptions = response["CountryFilterOptions"];
        this.PartnerTypes = response["PartnerTypes"];
        this.ReceivedStatuses = response["ReceivedStatuses"];
        this.EFacturaSupplierFileRowTypes = response["EFacturaSupplierFileRowTypes"];
        this.TranzactionTypes = response["TranzactionTypes"];
        this.GetPaymentsMasterData();

        this.Filter.SortingOrder = this.SortingOrders[0];
      }

      this.parent.loading = false;
    });

  }

  GetPaymentsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetPaymentsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.BankAccounts = response["BankAccounts"];
        this.PaymentTypes = response["PaymentTypes"];
        this.PaymentCategories = response["PaymentCategories"].filter(x => x.ID != -1);
        this.GetReceptionsFiltered();
      }
   
      this.parent.loading = false;
    });
  }

  InitializeEFacturaFilter(){
    this.EFacturaFilter = {};
    this.EFacturaFilter.FromDate = null;
    this.EFacturaFilter.ToDate = null;

    this.EFacturaFilter.VATNumber = "";
    this.EFacturaFilter.CreateAutomaticReceptions = false;
    this.EFacturaFilter.Period = {};
    this.EFacturaFilter.Period = null;

    this.EFacturaFilter.Pager = {};
    this.EFacturaFilter.Pager.PageIndex = 1;
    this.EFacturaFilter.Pager.PageSize = 999999;
    this.EFacturaFilter.Pager.TotalCount = 0;
    
    this.EFacturaFilter.GetCompanyNames = true;
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Administration = {};
    this.Filter.AccountingSeries = {};
    this.Filter.Product = "";
    this.Filter.Partner = {};
    this.Filter.DocumentNumber = "";
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;

    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.SortingOrder = {};
    this.Filter.SortingOrder = null;

    this.Filter.CountryFilterOption = {};
    this.Filter.CountryFilterOption = null;

    this.Filter.PartnerType = {};
    this.Filter.PartnerType = null;

    this.Filter.ReceivedStatus = {};
    this.Filter.ReceivedStatus = null;

    this.Filter.TranzactionType = {};
    this.Filter.TranzactionType = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.ExchangeToTargetCurrency = true;
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
    this.EFacturaFilter.Period = null;
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];

         if(this.Partners.length == 1){
          this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
          this.GetReceptionsFiltered(1);
         }
        }
     
        this.parent.loading = false;
      });
    }
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }
     
        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

loadingEFacturaDocuments:boolean = false;

GetEFacturaSupplierFiles(page = 1){

  this.EFacturaFilter.Pager.PageIndex = page;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.EFacturaFilter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.EFacturaFromDate.value._d).format('YYYY-MM-DD');
    this.EFacturaFilter.FromDate = moment(this.EFacturaFromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.EFacturaToDate.value._d).format('YYYY-MM-DD');
    this.EFacturaFilter.ToDate = moment(this.EFacturaToDate.value._d).format('YYYY-MM-DD');
  }
  
  this.loadingEFacturaDocuments = true;

  this.service.GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1 || response["Status"] == 0){
      this.EFacturaSupplierFiles = response["Rows"];
      this.EFacturaStepTwo = true;
      this.EFacturaStepOne = false;

      this.EFacturaFromDate = new FormControl(moment(this.EFacturaFilter.FromDate));
      this.EFacturaToDate = new FormControl(moment(this.EFacturaFilter.ToDate));
    }
 
    this.loadingEFacturaDocuments = false;
  });
}

  GetReceptionsFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    if(this.Filter.DisplayAllPagesTotals == true){
      this.Filter.ExchangeToTargetCurrency = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetReceptionsFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Receptions = response["Receptions"];
        this.Totals = response["Totals"];

        // Map cached PO summary data from backend LEFT JOIN
        if(this.Receptions && this.Receptions.length > 0){
          this.Receptions.forEach(r => {
            if(r.POProductSummary?.TotalProductsCount > 0){
              var s = r.POProductSummary;
              var total = s.TotalProductsCount;
              r.POProductInfo = {
                QuantityExceeded: s.QuantityExceededCount,
                PriceDifference: s.PriceDifferenceCount,
                PriceNotFound: s.PriceNotFoundCount,
                ExpectedPrice: s.ExpectedPriceCount,
                QuantityExceededPercent: total > 0 ? (s.QuantityExceededCount / total) * 100 : 0,
                PriceDifferencePercent: total > 0 ? (s.PriceDifferenceCount / total) * 100 : 0,
                PriceNotFoundPercent: total > 0 ? (s.PriceNotFoundCount / total) * 100 : 0,
                ExpectedPricePercent: total > 0 ? (s.ExpectedPriceCount / total) * 100 : 0
              };
            }
          });
        }

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
        this.AllSelected = false;
      }

      this.loading = false;
    });

    this.GetReceptionsFilteredCOUNT();

  }

  GetReceptionsFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.service.GetReceptionsFilteredCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
   
    });
  }

  ShowDeleteReceptionQuestion:boolean;
  ShowDeleteReceptionRelatedPayments:boolean;

  DeleteReception(reception:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:reception.ID,
      DetailsID:reception.Details.ID,
      AccountingNumber:reception.AccountingNumber,
      GetAssociatedPayments:true
    };

    this.loading = true;

    this.service.DeleteReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       this.GetReceptionsFiltered();
       this.showReceptionVisualizer = false;
       
       this.SuggestedPayments = response["Payments"];

       if(this.SuggestedPayments != null && this.SuggestedPayments.length > 0){
        this.ShowDeleteReceptionRelatedPayments = true;
       }
      }

      this.loading = false;
    });

  }

  ActivateReception(reception:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:reception.ID,
    };

    this.loading = true;

    this.service.ActivateReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.GetReceptionsFiltered();
       
       if(this.CurrentReception != null && this.CurrentReception.ID != null){
         this.GetReception(this.CurrentReception);
       }

      }

      this.loading = false;
    });

  }

  ShowDeactivateDocumentQuestion:boolean;
  ShowReactivateDocumentQuestion:boolean;

  CancelReception(reception:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:reception.ID,
    };

    this.loading = true;

    this.service.CancelReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.GetReceptionsFiltered();

       if(this.CurrentReception != null && this.CurrentReception.ID != null){
        this.GetReception(this.CurrentReception);
      }
      }

      this.loading = false;
    });

  }

  initializePartnerFormFromObject(partner:any){

    this.currentPartner = new FormGroup({

      VAT:new FormControl(partner.VAT),
      UPN:new FormControl(partner.UPN),
      Name:new FormControl(partner.Name, [Validators.required]),
      COCRegNumber:new FormControl(partner.COCRegNumber),
  
      TaxPayer:new FormControl(partner.TaxPayer),
  
      Country:new FormControl(partner.BillingAddress.Country),
      StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
      City:new FormControl(partner.BillingAddress.City, [Validators.required]),
      AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),
  
      Bank:new FormControl(partner.Bank),
      BankAccount:new FormControl(partner.Bank.BankAccount),
  
      Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
      ContactName:new FormControl(partner.ContactInfo.Name),
      Phone:new FormControl(partner.ContactInfo.Phone),
    });
   
    this.showEditPartnerPopUp = true;
    this.partner = partner;
  }

  UpdatePartner(){
    var request = {
      Partner:{
        ID:String,
        VAT:this.currentPartner.controls['VAT'].value,
        UPN:this.currentPartner.controls['UPN'].value,
        Name:this.currentPartner.controls['Name'].value,
        COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,

        TaxPayer:this.currentPartner.controls['TaxPayer'].value,

        BillingAddress:{
          ID:Number,
          Country:this.currentPartner.controls['Country'].value,
          StateProvince:this.currentPartner.controls['StateProvince'].value,
          City:this.currentPartner.controls['City'].value,
          AddressLine:this.currentPartner.controls['AddressLine'].value,
        },
        Bank:this.currentPartner.controls['Bank'].value,
        ContactInfo:{
          ID:Number,
          Email:this.currentPartner.controls['Email'].value,
          Name:this.currentPartner.controls['ContactName'].value,
          Phone:this.currentPartner.controls['Phone'].value,
        },
        Company:this.parent.Company,
        EUVATVerified:this.partner.EUVATVerified,
      },
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
    request.Partner.ID = this.partner.ID;
    request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
    request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;

    this.parent.loading = true;

    this.service.UpdatePartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
       this.showEditPartnerPopUp = false;
       this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
       this.partner = response["Partner"];
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerEUData(partner:any, addnew:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){

        if(addnew){

          this.newPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(''),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(''),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(''),
            City:new FormControl(''),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
        
            Bank:new FormControl(''),
            BankAccount:new FormControl(''),
        
            Email: new FormControl('', [Validators.email]),
            ContactName:new FormControl(''),
            Phone:new FormControl(''),
          });
        }
        else{

          this.currentPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(this.partner.UPN),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(this.partner.COCRegNumber),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
            City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
        
            Bank:new FormControl(this.partner.Bank),
            BankAccount:new FormControl(this.partner.Bank.BankAccount),
        
            Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
            ContactName:new FormControl(this.partner.ContactInfo.Name),
            Phone:new FormControl(this.partner.ContactInfo.Phone),
          });

          this.partner.EUVATVerified = response["EUVATVerified"];
        }
      }
   
      this.parent.loading = false;
    });
  }

  ViewReception(r:any){

    if(r.DocumentStatus.ID == -1){
      return;
    }

    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/purchases/reception'], { queryParams: { id: r.ID } }));
    window.open(nextUrl, '_blank');
    // this.router.navigate(['/dashboard/purchases/reception'], { queryParams: { id: r.ID } }); 
  }

  GenerateStorno(r:any){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/purchases/reception'], { queryParams: { id: r.ID, IsStorno: true } }));
    window.open(nextUrl, '_blank');
    // this.router.navigate(['/dashboard/purchases/reception'], { queryParams: { id: r.ID, IsStorno: true } }); 
  }

  GetReception(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:r.ID,
      WithInfo:true,
      ExchangeToTargetCurrency:this.Filter.ExchangeToTargetCurrency,
      IncludeTaxDistributionsInPrice:true
    };

    this.loadingReceptionID = r.ID;
    this.loadingDocumentInformation = true;

    this.service.GetReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception = response["Reception"];
        this.CurrentReception.Products = this.CurrentReception.Products.filter(x => x.ProductReceptionInfo.GeneralType.IsTaxConsumed != true);
        this.showReceptionVisualizer = true;
      }

      this.loadingReceptionID = null;
      this.loadingDocumentInformation = false;
    });
  }

  PrintEFacturaFiles(){
    this.EFacturaSupplierFiles.forEach(row => {
      if(row.IsSelected){
        this.PrintEFacturaFile(row);
      }
    });
  }

  PrintEFacturaFile(Row:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Row:Row,
    };

    this.parent.loading = true;

    this.service.PrepareEFacturaSupplierDocumentsFiles(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["PDF"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.parent.loading = false;
    });
  }

  ExportEFacturaFiles(){
    this.EFacturaSupplierFiles.forEach(row => {
      if(row.IsSelected){
        this.ExportEFacturaFile(row);
      }
    });
  }

  ExportEFacturaFile(Row:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Row:Row,
    };

    this.parent.loading = true;

    this.service.PrepareEFacturaSupplierDocumentsFiles(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["PDF"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.parent.loading = false;
    });
  }

  ExportReception(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:r.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.DocumentBodyLoading = false;
    });
  }

  PrintReception(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:r.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.DocumentBodyLoading = false;
    });
  }

   printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

  VizualizeDocument(r:any){
    this.GetReception(r);
  }

   download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "DocStatus"){
      this.Filter.DocumentStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Currency"){
      this.Filter.Currency = null;
    }
    else if(filterType == "ReceivedStatus"){
      this.Filter.ReceivedStatus = null;
    }
    else if(filterType == "TranzactionType"){
      this.Filter.TranzactionType = null;
    }

    this.GetReceptionsFiltered();
}

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.GetReceptionsFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.EFacturaFilter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  ExportAllOrPageOnlyQuestion:boolean;

  ExportReceptionsValues(allPages:boolean = false){

    this.Filter.Pager.PageIndex = 1;
  
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter,
        AllPages:allPages
      };
  
      if(request.Filter.FromDate != null){
        request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
        this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      }
  
      if(request.Filter.ToDate != null){
        request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
        this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      }
      
      this.parent.loading = true;
      this.showFilter = false;
  
      this.service.ExportReceptionsValues(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
        }

        this.parent.loading = false;
      });
  }

  GenerateSAGAReceptionExport(allPages:boolean = false){

    this.Filter.Pager.PageIndex = 1;

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter,
        AllPages:allPages
      };

      if(request.Filter.FromDate != null){
        request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
        this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      }

      if(request.Filter.ToDate != null){
        request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
        this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      }

      this.parent.loading = true;
      this.showFilter = false;

      this.service.GenerateSAGAReceptionExport(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.downloadSAGAExport(Document.Name, Document.PDFStream);
        }

        this.parent.loading = false;
      });
  }

  downloadSAGAExport(filename, base64Content){
    let fileName = filename || 'SAGA_Export';
    if (fileName.toLowerCase().endsWith('.pdf')) {
      fileName = fileName.substring(0, fileName.length - 4);
    }
    if (!fileName.toLowerCase().endsWith('.xml')) {
      fileName = fileName + '.xml';
    }

    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/xml' });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  GetReceptionPayments(detailsID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionDetailsID:detailsID
    };
    
    this.loading = true;
  
    this.service.GetReceptionPayments(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SuggestedPayments = response["Payments"];
        this.PaymentTotals = response["Totals"];
        this.ShowSuggestionPaymentsContainer = true;
      }
   
      this.loading = false;
    });
  }

  ReselectBankAccount(c:any){
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == c.ID)[0];
  }

  ClonePayment(c:any){
    this.currentPayment = JSON.parse(JSON.stringify(c));
  
    this.PaymentCategories.forEach(c => {
      if(c.ID == this.currentPayment.Category.ID){
        this.currentPayment.Category = c;
      }
    });
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
  }

  DeletePayments(payments:any[]){
    payments.forEach(p => {
      this.DeletePayment(p.ID);
    });
  }
  
  DeletePayment(ID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:ID,
    };
  
    this.parent.loading = true;
  
    this.service.DeletePayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SuggestedPayments = this.SuggestedPayments.filter(x => x.ID != ID);
        this.ShowDeleteSpendingQuestion = false;
        this.currentPayment = null;
        this.GetReceptionsFiltered(this.Filter.Pager.PageIndex);
      }
  
      if(this.SuggestedPayments == null || this.SuggestedPayments.length == 0){
        this.ShowSuggestionPaymentsContainer = false;
      }

      this.parent.loading = false;
    });
  }

  OpenSuggestedPaymentModifier(c:any){

    this.currentPayment = c;
  
    this.PaymentCategories.forEach(c => {
      if(c.ID == this.currentPayment.Category.ID){
        this.currentPayment.Category = c;
      }
    });
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
    
    if(this.currentPayment.ReceptionDetailsID == null || this.currentPayment.ReceptionDetailsID == undefined){
      this.currentPayment.ReceptionDetailsID = "";
    }
  
    if(this.currentPayment.ReceptionID == null || this.currentPayment.ReceptionID == undefined){
      this.currentPayment.ReceptionID = "";
    }
  
    this.CollectionDate = new FormControl(moment(this.currentPayment.PaymentDate));
  
    if(this.currentPayment.BankAccount == null){
      this.ReselectBankAccount(this.currentPayment.Currency);
    }
  }

  SearchedReceptions:any[];

  SearchReceptions(s:string){

    if(s.length > 2){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        SearchTerm:s,
        WithPartnerInfo:true
      };
  
      this.service.SearchReceptions(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.SearchedReceptions = response["Receptions"];
        }
     
        this.parent.loading = false;
      });
    }
  }

  ShowMustSelectSinglePartnerError:boolean;

  ProofSinglePartnerSelected() : boolean {
    this.ShowMustSelectSinglePartnerError = false;
  
    var samePartner = this.Receptions.filter(x => x.IsSelected == true).every( a => a.Supplier.ID === this.Receptions.filter(x => x.IsSelected == true)[0].Supplier.ID);
  
    if(!samePartner){
      this.ShowMustSelectSinglePartnerError = true;
    }
  
    return this.ShowMustSelectSinglePartnerError;
  }

  InitializeNewPayment(r:any){

    if(this.ProofOriginalCurrencyError() == true){
      return;
    }

    if(this.ProofSinglePartnerSelected() == true){
      return;
    }

    if(r.Currency.ID != r.InitialSavedCurrency.ID && this.Filter.ExchangeToTargetCurrency){
      this.ShowOriginalCurrencyError = true;
      return;
    }

    this.IsCollectivePayment = false;
    this.ShowPaymentContainer = true; 
    this.currentPayment = {};
    this.currentPayment.Type = this.PaymentTypes[1];
    this.currentPayment.Currency = r.Currency;
    this.currentPayment.Currency.DecimalPrecision = this.DecimalPrecisions[0];
    this.CollectionDate = new FormControl(moment());
    this.currentPayment.PaymentDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
    this.currentPayment.ID = 0;
  
    this.currentPayment.BankAccount = {};
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentPayment.Currency.ID)[0];
  
    this.currentPayment.Category = {};
    this.currentPayment.Category = this.PaymentCategories[0];
  
    this.currentPayment.ReceptionID = r.ID;
    this.currentPayment.ReceptionDetailsID = r.Details.ID;
    this.CurrentReception = r;

    if(this.CurrentReception.Details.PaymentRemainingValue > 0){
      this.currentPayment.Value = JSON.parse(JSON.stringify(this.CurrentReception.Details.PaymentRemainingValue));
      this.PaymentRemainingValue = JSON.parse(JSON.stringify(this.CurrentReception.Details.PaymentRemainingValue));
    }
  }

  InitializeNewCollectivePayment(){

    this.ShowDeactivatedDocumentsOnSelectAllQuestion = false;

    if(this.ProofSingleCurrencyOnCollectivePayment() == true){
      return;
    }

    this.IsCollectivePayment = true;
    var r = this.Receptions.filter(x => x.IsSelected == true)[0];
    this.ShowPaymentContainer = true; 
    this.currentPayment = {};
    this.currentPayment.Type = this.PaymentTypes[1];
    this.currentPayment.Currency = r.Currency;
    this.currentPayment.Currency.DecimalPrecision = this.DecimalPrecisions[0];
    this.CollectionDate = new FormControl(moment());
    this.currentPayment.PaymentDate = moment(this.CollectionDate.value._d).format('YYYY-MM-DD');
    this.CollectionDate = new FormControl(moment(this.currentPayment.CollectionDate));
    this.currentPayment.ID = 0;
  
    this.currentPayment.BankAccount = {};
    this.currentPayment.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentPayment.Currency.ID)[0];
  
    this.currentPayment.Category = {};
    this.currentPayment.Category = this.PaymentCategories[0];
  
    this.currentPayment.ReceptionID = r.ID;
    this.currentPayment.ReceptionDetailsID = r.Details.ID;
    this.currentPayment.Value = 0;

    this.Receptions.forEach(element => {
      if(element.IsSelected){
        if(element.Details.PaymentRemainingValue > 0){
          this.currentPayment.Value = this.currentPayment.Value + JSON.parse(JSON.stringify(element.Details.PaymentRemainingValue));
          this.PaymentRemainingValue = this.PaymentRemainingValue + JSON.parse(JSON.stringify(element.Details.PaymentRemainingValue));
        }
      }
    });
  }

  AddPayment(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Payment:this.currentPayment,
    };
  
    if(this.CollectionDate.value != null){
      if(this.CollectionDate.value._d != undefined){
        request.Payment.CollectionDate = moment(this.CollectionDate.value._d).format('YYYY-MM-DD');
        this.CollectionDate = new FormControl(moment(this.CollectionDate.value._d).format('YYYY-MM-DD'));
      }
      else{
        request.Payment.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
        this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
      }
    }
  
    this.parent.loading = true;
  
    this.service.AddPayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetReceptionsFiltered(this.Filter.Pager.PageIndex);
      }
      
  
      this.CollectionDate = new FormControl(moment());
      this.parent.loading = false;
    });
  }

  AddGroupPayment(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Payment:this.currentPayment,
      Receptions:this.Receptions.filter(x => x.IsSelected == true)
    };
  
    if(this.CollectionDate.value != null){
      if(this.CollectionDate.value._d != undefined){
        request.Payment.CollectionDate = moment(this.CollectionDate.value._d).format('YYYY-MM-DD');
        this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
      }
      else{
        request.Payment.CollectionDate = moment(this.CollectionDate.value._d).format('YYYY-MM-DD');
        this.CollectionDate = new FormControl(moment(this.CollectionDate.value._d).format('YYYY-MM-DD'));
      }
    }
  
    this.parent.loading = true;
  
    this.service.AddGroupPayment(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetReceptionsFiltered();
      }
  
      this.CollectionDate = new FormControl(moment());
      this.parent.loading = false;
    });
  }

  GeneratePurchaseContractFromReception(c){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:c.ID,
    };
   
    this.parent.loading = true;
  
    this.service.GeneratePurchaseContractFromReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      
      this.parent.loading = false;
    });
  }

  DownloadFile(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:r.ID,
    };
  
    this.parent.loading = true;
  
    this.service.DownloadReceptionFile(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
  
      this.parent.loading = false;
    });
  }

  AutoPrintDocument(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionID:i.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.ExportReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.parent.AutoPrintDocument(Document);
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  SelectAll(){
    this.Receptions.forEach(r => {
      r.IsSelected = this.AllSelected;
    });

    this.CheckIfAnyChecked();
  }

  EFacturaAllSelected:boolean;

  SelectAllEFactura(){
    this.EFacturaSupplierFiles.forEach(row => {
      row.IsSelected = this.EFacturaAllSelected;
    });

    this.CheckIfAnyCheckedEFactura();
  }

  AnyCheckedEfactura:boolean;

  CheckIfAnyCheckedEFactura(){
    this.AnyCheckedEfactura = false;

    this.EFacturaSupplierFiles.forEach(row => {
      if(row.IsSelected){
        this.AnyCheckedEfactura = true;
      }
    });
  }

  ShowDeactivatedDocumentsOnSelectAllQuestion:boolean;
  SingleCurrencyOnCollectivePaymentError:boolean;
  ShowOriginalCurrencyError:boolean;

  ProofSingleCurrencyOnCollectivePayment() : boolean {
    this.SingleCurrencyOnCollectivePaymentError = false;
    var currencies = [];

    this.Receptions.forEach(r => {
      if(r.IsSelected == true){
        if(!currencies.find(x => x == r.InitialSavedCurrency?.ID) && r.InitialSavedCurrency != null){
          currencies.push(r.InitialSavedCurrency?.ID);
        }        
      }
    });

    if(currencies.length > 1){
      this.SingleCurrencyOnCollectivePaymentError = true;
    }

    return this.SingleCurrencyOnCollectivePaymentError;
  }

  AlertDeactivatedDocumentsOnSelectAll(r:any){
    
    if(this.ProofOriginalCurrencyError() == true){
      return;
    }

    if(this.ProofSinglePartnerSelected() == true){
      return;
    }

    this.Receptions.find(x => x.ID == r.ID).IsSelected = true;
    var exists = false;
    
    this.Receptions.forEach(r => {
      if(r.Status.ID == -1 && r.IsSelected == true){
        exists = true;
      }
    });

    if(exists){
      this.ShowDeactivatedDocumentsOnSelectAllQuestion = true;
    }
    else{
      this.InitializeNewCollectivePayment();
    }
  }

  DeselectDeactivatedDocs(){
    this.Receptions.forEach(r => {
      if(r.Status.ID == -1 && r.IsSelected == true){
        r.IsSelected = false;
      }
    });
  }

  ProofOriginalCurrencyError() : boolean {

    this.ShowOriginalCurrencyError = false;

    if(this.Filter.ExchangeToTargetCurrency){

      this.Receptions.forEach(r => {
        if(r.IsSelected == true && r.Currency.ID != r.InitialSavedCurrency.ID){
          this.ShowOriginalCurrencyError = true;
        }
      });
    }

    return this.ShowOriginalCurrencyError;
  }

  VerifyPriceModel(p:string){
    var result = this.parent.NormalizePrice(p);
  
    if(this.currentPayment != null){
      this.currentPayment.Value = result;
    }
  }

  ConnectedServiceProducts:any[];
  ConnectedService:any;
  ShowConnectedServiceContainer:boolean;

  SearchReceptionProductsFromConnectedService(r:any, service:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Reception:r,
      ServiceName:service
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.SearchReceptionProductsFromConnectedService(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ConnectedServiceProducts = response["Products"];
        this.ConnectedService = response["ServiceProperties"];
        this.ShowConnectedServiceContainer = true;
        this.showReceptionVisualizer = false;
      }
  
      this.DocumentBodyLoading = false;
      this.parent.loading = false;
    });
  }

  SelectConnectedServiceProduct(product:any){

    var SelectedState = JSON.parse(JSON.stringify(product.IsSelected));

    this.ConnectedServiceProducts.forEach(element => {
      element.IsSelected = false;
    });

    product.IsSelected = !SelectedState;
  }

  ReinitializeConnectedServiceProductResults(product:any, service:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Product:product,
      ServiceName:service
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.ReinitializeConnectedServiceProductResults(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        var p = response["Product"];

        this.ConnectedServiceProducts.forEach(element => {
          if(p.FoxCloudProductID == element.FoxCloudProductID){
            element.SuggestedProducts = JSON.parse(JSON.stringify(p.SuggestedProducts));
            element.UnallocatedQuantity = JSON.parse(JSON.stringify(p.UnallocatedQuantity));
          }
        });
      }
  
      this.DocumentBodyLoading = false;
      this.parent.loading = false;
    });
  }

  ConnectedServiceSuggestionProductSelectionChange(product:any, sp:any, service:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Product:product,
      SuggestedProduct:sp,
      ServiceName:service
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.ConnectedServiceSuggestionProductSelectionChange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");

        var p = response["Product"];

        this.ConnectedServiceProducts.forEach(element => {
          if(p.FoxCloudProductID == element.FoxCloudProductID){
            element.SuggestedProducts = JSON.parse(JSON.stringify(p.SuggestedProducts));
            element.UnallocatedQuantity = JSON.parse(JSON.stringify(p.UnallocatedQuantity));
          }
        });
      }
      else if(response["Status"] == 1){

        var p = response["Product"];

        this.ConnectedServiceProducts.forEach(element => {
          if(p.FoxCloudProductID == element.FoxCloudProductID){
            element.SuggestedProducts = JSON.parse(JSON.stringify(p.SuggestedProducts));
            element.UnallocatedQuantity = JSON.parse(JSON.stringify(p.UnallocatedQuantity));
          }
        });
      }
  
      this.DocumentBodyLoading = false;
      this.parent.loading = false;
    });
  }

  GetExtraResultProductsFromConnectedService(product:any, service:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Product:product,
      ServiceName:service
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.GetExtraResultProductsFromConnectedService(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        var p = response["Product"];

        this.ConnectedServiceProducts.forEach(element => {
          if(p.FoxCloudProductID == element.FoxCloudProductID){
            element.SuggestedProducts = JSON.parse(JSON.stringify(p.SuggestedProducts));
            element.LastSearchVariant = JSON.parse(JSON.stringify(p.LastSearchVariant));
            element.IsSelected = true;
          }
          else{
            element.IsSelected = false;
          }
        });
      }
  
      this.DocumentBodyLoading = false;
      this.parent.loading = false;
    });
  }

  AddUpdateConnectedServiceSuggestedStockProduct(product:any, pressedProduct:any, service:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Product:product,
      PressedProduct:pressedProduct,
      ServiceName:service
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.AddUpdateConnectedServiceSuggestedStockProduct(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        var p = response["Product"];

        this.ConnectedServiceProducts.forEach(element => {
          if(p.FoxCloudProductID == element.FoxCloudProductID){
            element.SuggestedProducts = JSON.parse(JSON.stringify(p.SuggestedProducts));
            element.UnallocatedQuantity = JSON.parse(JSON.stringify(p.UnallocatedQuantity));
          }
        });
      }
  
      this.DocumentBodyLoading = false;
      this.parent.loading = false;
    });
  }

  DeleteConnectedServiceSuggestedProduct(product:any, pressedProduct:any, service:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Product:product,
      PressedProduct:pressedProduct,
      ServiceName:service
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.DeleteConnectedServiceSuggestedProduct(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        var p = response["Product"];

        this.ConnectedServiceProducts.forEach(element => {
          if(p.FoxCloudProductID == element.FoxCloudProductID){
            element.SuggestedProducts = JSON.parse(JSON.stringify(p.SuggestedProducts));
            element.UnallocatedQuantity = JSON.parse(JSON.stringify(p.UnallocatedQuantity));
            element.LastSearchVariant = JSON.parse(JSON.stringify(p.LastSearchVariant));
          }
        });
      }
  
      this.DocumentBodyLoading = false;
      this.parent.loading = false;
    });
  }

  ShowPushConnectedServiceResults:boolean;

  OpenShowPushConnectedServiceResults(){
    this.ShowPushConnectedServiceResults = true;
    this.ShowConnectedServiceContainer = false;
  }

  PushConnectedServiceResults(products:any, service:string, r:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Products:products,
      ServiceName:service,
      DocumentID:r.ID
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.PushConnectedServiceResults(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
  
      this.DocumentBodyLoading = false;
      this.parent.loading = false;
    });
  }

  GetConnectedServicePushLog(r:any, service:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DocumentID:r.ID,
      ServiceName:service
    };
  
    this.parent.loading = true;
    this.DocumentBodyLoading = true;
  
    this.service.GetConnectedServicePushLog(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.parent.loading = false;
        this.DocumentBodyLoading = false;
      }
      else if(response["Status"] == 1){
        this.SearchReceptionProductsFromConnectedService(r, service);
      }
      else if(response["Status"] == 0){
        this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar", 50000);
        this.parent.loading = false;
        this.DocumentBodyLoading = false;
      }
    });
  }

  AnyChecked:boolean;

  CheckIfAnyChecked(){
    this.AnyChecked = false;

    this.Receptions.forEach(element => {
      if(element.IsSelected){
        this.AnyChecked = true;
      }
    });
  }

  AutoPrintReceptions(){

    var ids = [];
  
    this.Receptions.forEach(element => {
      if(element.IsSelected){
        ids.push(element.ID);
      }
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionIDs:ids
    };
  
    this.parent.loading = true;
    this.ShowAutoPrintBulkQuestion = false;
  
    this.service.AutoPrintReceptions(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
  
      this.parent.loading = false;
    });
  }

  ShowAutoPrintBulkQuestion:boolean;
  ShowStockEntryDateTodayQuestion:boolean;

  ModifyReceptionStockEntryDatesToToday(){
    var ids:string[] = [];

    this.Receptions.forEach(element => {
      if(element.IsSelected){
        ids.push(element.ID);
      }
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ReceptionIDs:ids
    };

    this.parent.loading = true;
    this.ShowStockEntryDateTodayQuestion = false;

    this.service.ModifyReceptionStockEntryDates(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.GetReceptionsFiltered(this.Filter.Pager.PageIndex);
      }

      // Reset selection states
      this.AllSelected = false;
      this.AnyChecked = false;
      this.parent.loading = false;
    });
  }

  JuggleSorting(){
    for(var i=0;i<this.SortingOrders.length;i++){

      if(this.SortingOrders[i].ID == this.Filter.SortingOrder.ID){
        if(i < this.SortingOrders.length - 1){
          this.Filter.SortingOrder = this.SortingOrders[i + 1];
          break;
        }
        else{
          this.Filter.SortingOrder = this.SortingOrders[0];
        }
      }
    }

    this.GetReceptionsFiltered(this.Filter.Pager.PageIndex);
  }

  ShippingWays:any[];
  ShippingServiceTypes:any[];
  ShippingResponsabilities:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  ShippingMasterData:any;
  ShowShippingDetailsContainer:boolean;

  GetShippingDetails(DetailsID:number, PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ParentDetailsID:DetailsID,
      ShippingMasterData:this.ShippingMasterData,
      PartnerID:PartnerID
    };
  
    this.parent.loading = true;
  
    this.service.GetReceptionShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
        this.ShowShippingDetailsContainer = true;
      }
      else if(response["Status"] == 0){
        this.parent.openSnackBar(response["Message"], "OK", "warning-info-snackbar");
        this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
        this.ShowShippingDetailsContainer = true;
      }
  
      this.parent.loading = false;
    });
  }
  
  AddNewBox(ShippingDetailsID:number){
    var box = {
      ID:0,
      ParentShippingDetailsID:ShippingDetailsID,
      Length:10,
      Width:10,
      Height:10,
      Weight:1,
      TrackingLabel:null,
      UIID:this.parent.newGuid(),
    };
  
    this.CurrentReception.Details.ShippingDetails.Boxes.push(box);
  }
  
  ProofShippingDetails(ShippingDetails:number, SaveToDB:boolean = false){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.ProofReceptionShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowShippingDetailsContainer = false;
  
        if(SaveToDB == true){
  
          if(this.CurrentReception.Details.ShippingDetails.ID > 0){
            this.UpdateShippingDetails(this.CurrentReception.Details.ShippingDetails);
          }
          else{
            this.AddShippingDetails(this.CurrentReception.Details.ShippingDetails);
          }
        }
      }
    });
  }
  
  ShowDeleteBoxQuestion:boolean;
  CurrentBox:any;
  
  DeleteBox(UIID:string){
    this.CurrentReception.Details.ShippingDetails.Boxes = this.CurrentReception.Details.ShippingDetails.Boxes.filter(item => item.UIID != UIID);
  }
  
  AddShippingDetails(ShippingDetails:any){
    
    ShippingDetails.Partner = this.CurrentReception.Supplier;
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.service.AddReceptionShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
      }
  
      this.parent.loading = false;
    });
  }
  
  UpdateShippingDetails(ShippingDetails:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };
  
    this.parent.loading = true;
  
    this.service.UpdateReceptionShippingDetails(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
      }
  
      this.parent.loading = false;
    });
  } 

  ShowDeleteShippingDetailsContainer:boolean;

  DeleteShippingDetails(ShippingDetails:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:ShippingDetails,
    };

    this.parent.loading = true;

    this.service.DeleteReceptionShippingDetails(request).subscribe(response => {

      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentReception.Details.ShippingDetails = response["ShippingDetails"];
        this.ShowShippingDetailsContainer = false;
        this.parent.openSnackBar(response["Message"], "OK", "info-info-snackbar");
      }

      this.parent.loading = false;
    });
  }

  UnassociatedShipments:any[];
  UnassociatedShipmentsLoading:boolean = false;
  ShowUnassociatedShipments:boolean = false;
  UnassociatedSearchTerm:string = "";

  GetUnassociatedShippingDetails(){
    if(!this.CurrentReception?.Supplier?.ID){
      return;
    }

    // If already showing results, just toggle visibility
    if(this.UnassociatedShipments?.length > 0){
      this.ShowUnassociatedShipments = true;
      return;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.CurrentReception.Supplier.ID,
      DirectionID:-1
    };

    this.UnassociatedShipmentsLoading = true;
    this.ShowUnassociatedShipments = false;

    this.service.GetUnassociatedShippingDetails(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UnassociatedShipments = response["UnassociatedShipments"];
        if(this.UnassociatedShipments?.length > 0){
          this.ShowUnassociatedShipments = true;
        }
      }

      this.UnassociatedShipmentsLoading = false;
    });
  }

  CloseUnassociatedShipments(){
    this.ShowUnassociatedShipments = false;
    this.UnassociatedSearchTerm = "";
  }

  ConnectShippingDetailsToReception(shipment:any){
    if(!this.CurrentReception?.Details?.ID || !shipment?.ID){
      return;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetailsID:shipment.ID,
      ParentDetailsID:this.CurrentReception.Details.ID
    };

    this.parent.loading = true;

    this.service.ConnectShippingDetailsToReception(request).subscribe(response => {

      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.parent.loading = false;
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Shipping details connected successfully!", "OK", "light-info-snackbar");
        this.CloseUnassociatedShipments();
        this.ShowShippingDetailsContainer = false;
        this.parent.loading = false;
      }
    });
  }

  ShowExportBulkQuestion:boolean;

  AutoExportReceptions(){

    this.parent.loading = true;

    this.Receptions.forEach(i => {
      
      if(i.IsSelected == true){
        this.ExportReception(i);
      }
    });

    this.parent.loading = false;
  }

  ShowReceivedStatusConfirmation:boolean;
  InitialReceptions:any[];
  SavingReceptions:any[];

  ChangeReceivedStatus(r:any){

    var Received = JSON.parse(JSON.stringify(r.Details.ReceivedStatus.Received));
    r.Details.ReceivedStatus.Received = !r.Details.ReceivedStatus.Received;
    this.InitialReceptions = JSON.parse(JSON.stringify(this.Receptions));

    var newStatus = this.ReceivedStatuses.filter(x => x.Received == Received)[0];
    var receptions = [];

    for(var i=0;i<this.Receptions.length;i++){
     if(this.Receptions[i].IsSelected == true){
        this.Receptions[i].Details.ReceivedStatus = JSON.parse(JSON.stringify(newStatus));
        receptions.push(this.Receptions[i]);
     }
    }

    if(receptions.length == 0){
      r.Details.ReceivedStatus = newStatus;

      for(var i=0;i<this.Receptions.length;i++){
        if(this.Receptions[i].ID == r.ID){
           this.Receptions[i].Details.ReceivedStatus = JSON.parse(JSON.stringify(newStatus));
           this.Receptions[i].IsSelected = true;
           receptions.push(this.Receptions[i]);
           break;
        }
       }
    }

    this.SavingReceptions = receptions;
    this.ShowReceivedStatusConfirmation = true;
  }

  RevertReceptions(){

    this.SavingReceptions = [];

    this.InitialReceptions.forEach(element => {
      element.IsSelected = false;
    });

    this.Receptions = JSON.parse(JSON.stringify(this.InitialReceptions));
  }

  UpdateReceptionsReceivedStatuses(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Receptions:this.SavingReceptions,
    };

    this.parent.loading = true;

    this.service.UpdateReceptionsReceivedStatuses(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.RevertReceptions();
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

        this.Receptions.forEach(element => {
          element.IsSelected = false;
        });
      }
  
      this.parent.loading = false;
    });
  }

  ShowForceStatusContainer:boolean;

  ForceDocumentClosing(i:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DocumentID:i.ID,
      ForceDocumentClosing:!i.Details.ForceDocumentClosing
    };
  
    this.parent.loading = true;
  
    this.service.ForceReceptionDocumentClosing(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowForceStatusContainer = false;
        this.CurrentReception.Details.ForceDocumentClosing = !this.CurrentReception.Details.ForceDocumentClosing;
        this.CurrentReception.Status = response["DocumentStatus"];
      }
  
      this.parent.loading = false;
    });
  }
  
  EFacturaStepOne:boolean = false;
  EFacturaStepTwo:boolean = false;

  InitializeEFacturaStepOne(){
    this.EFacturaStepOne = true;
  }

  PrepareEFacturaReceptionImports(Rows:any, row:any){

    Rows.forEach(r => {
      if(row.DBID == r.DBID){
        r.IsSelected = true;
      }
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Rows:Rows?.filter(x => x.IsSelected == true)
    };
  
    this.parent.loading = true;
  
    this.service.PrepareEFacturaReceptionImports(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Rows = JSON.parse(JSON.stringify(response["Rows"]));

        for(var i=0; i < Rows.length; i++){
          this.EFacturaSupplierFiles.forEach(r => {
            if(r.ID == Rows[i].ID){
              r.Files = Rows[i].Files;
            }
          });
        }
      }
  
      this.parent.loading = false;
    });
  }

  isEFacturaImportButtonDisabled(): boolean {
    // Check if there is at least one element in EFacturaSupplierFiles
    // where the subobject Files?.Reception?.DocumentImportStatus is not NULL
    return !this.EFacturaSupplierFiles.some(file => 
      file.IsSelected == true && file?.Files?.Reception?.DocumentImportStatus != null
    );
  }

  AddBulkedEFacturaReceptionsAndSpendings(){

  }

  EditPreImportedReception(r:any){

    this.parent.writeIndexedDBObject(r.UIID, JSON.stringify(r));

    // Construct the URL with the UIID as a query parameter
    const newUrl = `dashboard/purchases/reception?PreImportUIID=${encodeURIComponent(r.UIID)}`;
     // Open a new tab without focusing on it
    const newTab = window.open(newUrl, '_blank', 'noopener,noreferrer');
    if (newTab) {
        newTab.blur(); // Try to blur the new tab if it opens
        window.focus(); // Focus back on the current window
    }
  }

  getObjectSizeInMB(obj: any): number {
    // Convert object to JSON string
    const jsonString = JSON.stringify(obj);
    
    // Get the size in bytes
    const byteSize = new Blob([jsonString]).size;
    
    // Convert bytes to megabytes
    const sizeInMB = byteSize / (1024 * 1024);
    
    return sizeInMB;
}

ShowFinalCheckImportEFactura:boolean;

FinalCheckImportEFactura(){
  this.ShowFinalCheckImportEFactura = true;
  this.EFacturaStepTwo = false;
}

ImportEFacturaFiles(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Rows:this.EFacturaSupplierFiles
  };

  this.parent.loading = true;

  this.service.ImportEFacturaFiles(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }

    this.parent.loading = false;
  });
}

GetShippingMasterData(WithROETransportData:boolean = false){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    WithROETransportData:WithROETransportData,
  };

  this.service.GetShippingMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShippingWays = response["ShippingWays"];
      this.ShippingServiceTypes = response["ShippingServiceTypes"];
      this.ShippingResponsabilities = response["ShippingResponsabilities"];
      this.ShippingCompanies = response["ShippingCompanies"];
      this.WeightTypes = response["WeightTypes"];

      this.ShippingMasterData = response;

      if(WithROETransportData == true){
        this.CustomsStations = JSON.parse(JSON.stringify(this.ShippingMasterData.CustomsStations));
        this.ETransportDocumentTypes = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportDocumentTypes));
        this.ETransportMeasuringUnits = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportMeasuringUnits));
        this.ETransportOperationReasons = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportOperationReasons));
        this.ETransportOperationTypes = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportOperationTypes));
        this.ETransportCustomsBureaus = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportCustomsBureaus));
      }
    }
  });
}

CustomsStations:any[];
ETransportDocumentTypes:any[];
ETransportMeasuringUnits:any[];
ETransportOperationReasons:any[];
ETransportOperationTypes:any[];
ETransportCustomsBureaus:any[];

ETransportCustomsStation:any;
ETransportDocumentType:any;
ETransportMeasuringUnit:any;
ETransportOperationReason:any;
ETransportOperationType:any;
ETransportCustomsBureau:any;
UITShippingCompany:any;
UITAutoPlatesNumber:string;

ShowETransportStepOne:boolean = false;

PrepareGenerateUITDataUX(Partner:any, GeneralDocType:number){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:Partner,
    GeneralDocType:GeneralDocType
  };

  this.DocumentBodyLoading = true;

  this.service.PrepareGenerateUITDataUX(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ETransportCustomsStation = response["CustomsStation"];
      this.ETransportDocumentType = response["ETransportDocumentType"];
      this.ETransportMeasuringUnit = response["ETransportMeasuringUnit"];
      this.ETransportOperationReason = response["ETransportOperationReason"];
      this.ETransportOperationType = response["ETransportOperationType"];
      this.UITShippingCompany = response["ShippingCompany"];
      this.UITAutoPlatesNumber = response["AutoPlatesNumber"];
      this.ETransportCustomsBureau = response["ETransportCustomsBureau"];

      this.ShowETransportStepOne = true;
    }

    this.DocumentBodyLoading = false;
  });
}

UploadETransportInvoice(r:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Document:r,
    AutoPlatesNumber:this.UITAutoPlatesNumber,
    CustomsStation:this.ETransportCustomsStation,
    ETransportDocumentType:this.ETransportDocumentType,
    ETransportMeasuringUnit:this.ETransportMeasuringUnit,
    ETransportOperationReason:this.ETransportOperationReason,
    ETransportOperationType:this.ETransportOperationType,
    ETransportCustomsBureau:this.ETransportCustomsBureau,
    ShippingCompany:this.UITShippingCompany,
  };

  this.DocumentBodyLoading = true;

  this.service.UploadETransportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      
    }

    this.DocumentBodyLoading = false;
  });
}

PrepareETransportStep1(){
  this.GetShippingMasterData(true);
  this.PrepareGenerateUITDataUX(this.CurrentReception?.Supplier, 1);
}

async LoadPOProductInfoBulk(){
  if(this.Receptions == null || this.Receptions.length == 0) return;
  if(this.loadingPOMatch) return;

  var selectedReceptions = this.Receptions.filter(x => x.IsSelected && x.DocumentStatus?.ID != -1);
  if(selectedReceptions.length == 0) return;

  this.loadingPOMatch = true;
  this.loadingPOMatchIndex = 0;
  this.loadingPOMatchTotal = selectedReceptions.length;

  for(let i = 0; i < selectedReceptions.length; i++){
    var r = selectedReceptions[i];

    this.loadingPOMatchIndex = i + 1;

    try {
      await this.ProcessReceptionPOMatch(r);
    } catch(e) {
      // Silent fail — PO matching is optional info
    }
  }

  this.loadingPOMatch = false;
}

ProcessReceptionPOMatch(r: any): Promise<void> {
  return new Promise((resolve) => {

    var getReceptionRequest = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ID: r.ID,
      WithInfo: true,
      ExchangeToTargetCurrency: false,
      IncludeTaxDistributionsInPrice: true
    };

    this.service.GetReception(getReceptionRequest).subscribe(receptionResponse => {

      if(receptionResponse["Status"] != 1 || receptionResponse["Reception"] == null){
        resolve();
        return;
      }

      var reception = receptionResponse["Reception"];
      var products = reception.Products?.filter(x => x.ProductReceptionInfo?.GeneralType?.ID == 1) || [];

      if(products.length == 0 || reception.Supplier == null){
        resolve();
        return;
      }

      var bulkRequest = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        Partner: reception.Supplier,
        Products: products,
        ReceptionID: reception.ID,
        ReceptionDate: reception.DocumentDate || null
      };

      this.service.GetExpectedPOProductsPricesBulk(bulkRequest).subscribe(bulkResponse => {

        if(bulkResponse["Status"] == 1 && bulkResponse["Summary"] != null){
          var summary = bulkResponse["Summary"];
          var total = summary.TotalProductsCount;
          r.POProductInfo = {
            QuantityExceeded: summary.QuantityExceededCount,
            PriceDifference: summary.PriceDifferenceCount,
            PriceNotFound: summary.PriceNotFoundCount,
            ExpectedPrice: summary.ExpectedPriceCount,
            QuantityExceededPercent: total > 0 ? (summary.QuantityExceededCount / total) * 100 : 0,
            PriceDifferencePercent: total > 0 ? (summary.PriceDifferenceCount / total) * 100 : 0,
            PriceNotFoundPercent: total > 0 ? (summary.PriceNotFoundCount / total) * 100 : 0,
            ExpectedPricePercent: total > 0 ? (summary.ExpectedPriceCount / total) * 100 : 0
          };
        }

        resolve();
      });
    });
  });
}

// ========== INTRASTAT ARRIVALS ==========

async GenerateIntrastatArrivalXML() {
  // Get selected reception IDs
  const selectedReceptionIDs = this.Receptions
    .filter(r => r.IsSelected)
    .map(r => r.ID);

  if (selectedReceptionIDs.length === 0) {
    this.parent.openSnackBar("Please select receptions for Intrastat export", "OK", "alert-info-snackbar");
    return;
  }

  // Reset progress state
  this.IntrastatProgressPercent = 0;
  this.IntrastatProgressMessage = 'Connecting...';
  this.IntrastatDetailMessage = '';
  this.IntrastatCurrentItem = 0;
  this.IntrastatTotalItems = selectedReceptionIDs.length;
  this.ShowIntrastatProgress = true;

  // Connect SignalR
  let signalRConnectionId = '';
  try {
    signalRConnectionId = await this.signalRService.connect();
    console.log('📊 SignalR connected with ID:', signalRConnectionId);
  } catch (error) {
    console.warn('📊 SignalR connection failed, proceeding without real-time updates', error);
  }

  // Subscribe to progress updates
  const progressSubscription = this.signalRService.searchItemCompleted$.subscribe(
    (update) => {
      console.log('📊 SignalR progress:', update.CompletedCount + '/' + update.TotalCount, update.ProgressPercent + '%');
      this.ngZone.run(() => {
        this.IntrastatProgressPercent = update.ProgressPercent;
        this.IntrastatProgressMessage = update.Message || 'Processing...';
        this.IntrastatDetailMessage = `${update.CompletedCount} / ${update.TotalCount}`;
        this.IntrastatCurrentItem = update.CompletedCount;
        this.IntrastatTotalItems = update.TotalCount;
      });
    }
  );

  this.ngZone.run(() => {
    this.IntrastatProgressMessage = 'Starting...';
  });

  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    ReceptionIDs: selectedReceptionIDs,
    SignalRConnectionId: signalRConnectionId
  };

  this.service.GenerateIntrastatArrivalXML(request).subscribe(response => {
    progressSubscription.unsubscribe();
    console.log('📊 HTTP response received');

    this.ngZone.run(() => {
      this.IntrastatProgressPercent = 100;
      this.IntrastatProgressMessage = 'Complete!';
    });

    setTimeout(() => {
      this.ngZone.run(() => {
        this.ShowIntrastatProgress = false;

        if (response["Status"] != 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        } else if (response["Status"] == 1) {
          if (response["Declarations"] && response["Declarations"].length > 0) {
            this.IntrastatDeclarations = response["Declarations"];
            this.ShowIntrastatValidation = true;
          }
        }
      });
    }, 300);
  }, error => {
    progressSubscription.unsubscribe();
    this.ngZone.run(() => {
      this.ShowIntrastatProgress = false;
      this.parent.openSnackBar("Error generating Intrastat Arrivals XML", "OK", "alert-info-snackbar");
    });
  });
}

DownloadIntrastatArrivalXML(declaration: any) {
  const base64 = declaration.Document.PDFStream;
  const fileName = declaration.Document.Name;

  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/xml' });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}

CloseIntrastatValidation() {
  this.ShowIntrastatValidation = false;
  this.IntrastatDeclarations = [];
}

OpenNewClaimForDocument(r:any){
  if(r.ID == null){
    return;
  }
  try {
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/claims'], { queryParams: { docid: r.ID, dir: -1 } }));
    window.open(nextUrl, '_blank');
  } catch(e) {
    console.error('Error opening new claim URL:', e);
  }
}

OpenWorkingClaim(r:any){
  if(r.Details?.ReceivedStatus?.ID != -1){
    return;
  }

  try {
    if(r.WorkingClaimID != null && r.Supplier?.ID != null){
      // Open existing working claim on internal management claims page
      const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/claims'], { queryParams: { id: r.WorkingClaimID } }));
      window.open(nextUrl, '_blank');
    } else if(r.Company?.ID != null) {
      // Open new claim for this reception (dir=-1 = import/reception)
      const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/claims'], { queryParams: { docid: r.ID, dir: -1 } }));
      window.open(nextUrl, '_blank');
    }
  } catch(e) {
    console.error('Error opening claim URL:', e);
  }
}

}
